(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33],{

/***/ 3238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5235);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4520);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2446);
// ../../react-shim.js


// src/breadcrumb.tsx





// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .kr)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .getValidChildren */ .WR)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list"
  }, clones)));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  Breadcrumb.displayName = "Breadcrumb";
}

// src/breadcrumb-item.tsx




// src/breadcrumb-separator.tsx


var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
}

// src/breadcrumb-link.tsx


var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbLink.displayName = "BreadcrumbLink";
}

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_utils__WEBPACK_IMPORTED_MODULE_1__/* .getValidChildren */ .WR)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_4__/* .__DEV__ */ .Ts) {
  BreadcrumbItem.displayName = "BreadcrumbItem";
}



/***/ }),

/***/ 3870:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotos",
      function () {
        return __webpack_require__(4657);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var index_esm = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/Footer/index.tsx + 2 modules
var Footer = __webpack_require__(7386);
// EXTERNAL MODULE: ./components/Navbar/index.js + 4 modules
var Navbar = __webpack_require__(6697);
// EXTERNAL MODULE: ./components/Container/index.tsx
var Container = __webpack_require__(1344);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(7573);
;// CONCATENATED MODULE: ./components/Layout/Default/styles.ts


var Top = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    "& .chakra-breadcrumb": {
        fontFamily: "$raleway",
        fontWeight: 600,
        fontSize: (0,polished_esm/* rem */.hO)(12),
        color: "$grey600",
        "& li": {
            "&:last-of-type": {
                color: "$emerald500"
            }
        }
    }
});
var Background = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    paddingTop: 60,
    backgroundImage: "url(/banner_gramas.webp)",
    backgroundSize: "cover",
    position: "relative"
});
var WrapBox = (0,stitches_config/* styled */.zo)("div", {});
var Box = (0,stitches_config/* styled */.zo)("div", {
    position: "relative",
    left: "50%",
    marginTop: 90,
    padding: "16px",
    transform: "translateX(-50%)",
    flexDirection: "column",
    background: "$white",
    borderRadius: "32px 32px 0 0",
    textAlign: "center",
    width: "90%",
    "@xl": {
        padding: "16px 90px",
        width: "auto",
        display: "inline-flex"
    }
});
var Category = (0,stitches_config/* styled */.zo)("h1", {
    fontFamily: "$domine",
    fontWeight: "bold",
    color: "$grey900",
    fontSize: (0,polished_esm/* rem */.hO)(24),
    "@md": {
        fontSize: (0,polished_esm/* rem */.hO)(54)
    }
});
var CategorySmall = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: " !important",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var ScientifcName = (0,stitches_config/* styled */.zo)("h2", {
    fontFamily: "$raleway",
    fontWeight: "normal !important",
    fontStyle: "italic",
    color: "$grey900",
    margin: "16px 0",
    fontSize: "".concat((0,polished_esm/* rem */.hO)(16), " !important")
});
var Main = (0,stitches_config/* styled */.zo)("main", {
    "& section": {
        paddingTop: 50,
        paddingBottom: 100
    }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var dist_index_esm = __webpack_require__(3382);
;// CONCATENATED MODULE: ./components/Layout/Default/index.tsx













var convertBreadcrumb = function(string) {
    return string.replace(/-/g, " ").replace(/oe/g, "\xf6").replace(/ae/g, "\xe4").replace(/ue/g, "\xfc").charAt(0).toUpperCase() + string.slice(1);
};
function Layout(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), breadcrumbs = ref[0], setBreadcrumbs = ref[1];
    (0,react.useEffect)(function() {
        if (router) {
            var linkPath = router.asPath.split("/");
            linkPath.shift();
            var pathArray = linkPath.map(function(path, i) {
                return {
                    breadcrumb: path.split("?")[0],
                    href: "/" + linkPath.slice(0, i + 1).join("/")
                };
            });
            setBreadcrumbs(pathArray);
        }
    }, [
        router
    ]);
    // if (!breadcrumbs) {
    //   return null
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: props.keywords
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://centraldagrama.com".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:card",
                        content: "summary_large_image"
                    }),
                    props.links && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://centraldagrama.com/".concat(props.links)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: props.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:description",
                        content: props.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:image",
                        content: "".concat(props.cover ? props.cover : "https://metatags.io/assets/meta-tags-16a33a6a8531e519cc0936fbba0ad904e52d35f34a46c97a2c9f6f7dd7d336f2.png")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Top, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                        css: props.categorySize ? (0,_object_spread/* default */.Z)({}, {
                                            fontSize: "".concat(props.categorySize, " !important")
                                        }) : {},
                                        children: props.category
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Breadcrumb */.aG, {
                                        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ChevronRightIcon */.XC, {
                                            color: "gray.600"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                        children: "In\xedcio"
                                                    })
                                                })
                                            }),
                                            breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map(function(breadcrumb, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbItem */.gN, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: breadcrumb.href,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BreadcrumbLink */.At, {
                                                            children: convertBreadcrumb(breadcrumb.breadcrumb)
                                                        })
                                                    })
                                                }, i);
                                            })
                                        ]
                                    }),
                                    props.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScientifcName, {
                                        children: props.subtitle
                                    }),
                                    props.h2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySmall, {
                                        children: props.h2
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};


/***/ }),

/***/ 7818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4767);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7573);


var Text = (0,styles_stitches_config__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("p", {
    fontFamily: "$raleway",
    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(13),
    lineHeight: "180%",
    variants: {
        align: {
            center: {
                textAlign: "center"
            }
        },
        type: {
            semiBold: {
                fontWeight: 600
            },
            bold: {
                fontWeight: "bold"
            },
            lead: {
                fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(11),
                fontWeight: 600,
                "@xxl": {
                    fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(18)
                }
            }
        },
        size: {
            sm: {
                fontSize: (0,polished__WEBPACK_IMPORTED_MODULE_1__/* .rem */ .hO)(12)
            }
        }
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 4657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(8641);
// EXTERNAL MODULE: ./components/Layout/Default/index.tsx + 1 modules
var Default = __webpack_require__(7309);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(872);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./styles/stitches.config.ts
var stitches_config = __webpack_require__(4767);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/avatar/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(3345);
// EXTERNAL MODULE: ./components/Typography/Text/index.tsx
var Text = __webpack_require__(7818);
;// CONCATENATED MODULE: ./components/Modal/styles.ts



var CardLeaf = (0,stitches_config/* styled */.zo)("div", {
    // maxHeight: 468,
    borderRadius: "0 100px 0 100px",
    border: "solid 1px",
    borderColor: "$emerald500",
    overflow: "hidden",
    cursor: "pointer",
    transition: "all 0.3s",
    "&:hover": {
        background: "$emerald50",
        transition: "all 0.3s"
    }
});
var Figure = (0,stitches_config/* styled */.zo)("figure", {
    position: "relative",
    height: 230,
    "@md": {
        height: 280
    }
});
var Image = (0,stitches_config/* styled */.zo)("img", {
    width: "100%",
    objectFit: "cover",
    height: "100%"
});
var Content = (0,stitches_config/* styled */.zo)("div", {
    padding: "30px 27px",
    h3: {
        fontSize: "20px !important"
    }
});
var Time = (0,stitches_config/* styled */.zo)("time", {
    marginBottom: 16,
    padding: "4px 8px",
    display: "inline-block",
    color: "$white",
    background: "$emerald500",
    fontFamily: "$manrope",
    fontSize: 13,
    borderRadius: 4
});
var AuthorWrap = (0,stitches_config/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    marginTop: 20,
    marginLeft: 15
});
var Avatar = (0,stitches_config/* styled */.zo)(dist_index_esm/* Avatar */.qE, {
    overflow: "hidden"
});
var Author = (0,stitches_config/* styled */.zo)(Text/* default */.Z, {
    color: "$grey600",
    marginLeft: 8
});
var Modal = (0,stitches_config/* styled */.zo)("div", {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: "50%",
    left: " 50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    zIndex: 99999
});
var ImageContainer = (0,stitches_config/* styled */.zo)("div", {
    cursor: "pointer"
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/Modal/index.tsx





var Modal_Modal = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardLeaf, {
                onClick: function() {
                    return setShowModal(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Figure, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: props.image,
                            layout: "fill",
                            objectFit: "cover",
                            title: props.metaImgTitle,
                            alt: props.metaImgAlt
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            props.time && /*#__PURE__*/ (0,jsx_runtime.jsx)(Time, {
                                children: props.time
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                title: props.metaTitle,
                                children: props.title
                            })
                        ]
                    })
                ]
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                onClick: function() {
                    return setShowModal(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: props.image,
                        title: props.metaImgTitle,
                        alt: props.metaImgAlt,
                        objectFit: "contain",
                        width: 550,
                        height: 550
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_Modal = (Modal_Modal);

;// CONCATENATED MODULE: ./pages/fotos/index.page.tsx





var Fotos = function(param) {
    var data = param.data;
    var ref;
    var ref1 = (0,react.useRef)(null);
    var list = data === null || data === void 0 ? void 0 : (ref = data.acf) === null || ref === void 0 ? void 0 : ref.images;
    console.log(list);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Default/* default */.Z, {
        category: "Fotos",
        title: "Fotos de Gramados, Gramas para Jardim",
        description: "Confira imagens de alguns de nossos trabalhos. Dentre eles destacamos jardins residenciais feitos por Eduardo Rusew especialista em paisagismo e jardinagem.",
        keywords: "fotos de grama, fotos de gramas, fotos grama esmeralda, fotos grama esmeralda premium, fotos grama batatais, fotos grama batatais plus, fotos grama s\xe3o carlos, fotos grama s\xe3o carlos plus, fotos grama bermuda, fotos grama bermuda celebration, fotos grama celebration, fotos grama tifton, fotos japonesa, fotos grama coreana, fotos grama inglesa, fotos grama santo agostinho",
        categorySize: "1.6rem",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Container */.W2, {
                maxW: "7xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                    columns: [
                        1,
                        1,
                        2,
                        null,
                        3
                    ],
                    spacing: 15,
                    ref: ref1,
                    children: list === null || list === void 0 ? void 0 : list.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_Modal, {
                            title: item === null || item === void 0 ? void 0 : item.title,
                            image: item.image
                        }, index);
                    })
                })
            })
        })
    });
};
var __N_SSG = true;
/* harmony default export */ var index_page = (Fotos);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [753,345,112,774,888,179], function() { return __webpack_exec__(3870); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);